import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A3D2E] text-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-4">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-12 h-12 bg-[#CDFF00] rounded-full flex items-center justify-center">
                <span className="text-[#0A3D2E] font-bold text-2xl">GC</span>
              </div>
              <span className="text-xl font-bold font-['Outfit']">Green Circuit EV</span>
            </div>
            <p className="text-base leading-relaxed text-white/80 mb-6">
              Powering South Africa's electric future with smart, reliable, and sustainable EV charging solutions.
            </p>
            <div className="flex space-x-4">
              <a href="#" data-testid="social-facebook" className="w-10 h-10 bg-white/10 hover:bg-[#CDFF00] rounded-full flex items-center justify-center transition-colors">
                <span className="text-white text-xl font-semibold">f</span>
              </a>
              <a href="#" data-testid="social-twitter" className="w-10 h-10 bg-white/10 hover:bg-[#CDFF00] rounded-full flex items-center justify-center transition-colors">
                <span className="text-white text-xl font-semibold">X</span>
              </a>
              <a href="#" data-testid="social-linkedin" className="w-10 h-10 bg-white/10 hover:bg-[#CDFF00] rounded-full flex items-center justify-center transition-colors">
                <span className="text-white text-xl font-semibold">in</span>
              </a>
              <a href="#" data-testid="social-instagram" className="w-10 h-10 bg-white/10 hover:bg-[#CDFF00] rounded-full flex items-center justify-center transition-colors">
                <span className="text-white text-xl font-semibold">ig</span>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-lg font-semibold mb-6 font-['Outfit']">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" data-testid="footer-home" className="text-white/80 hover:text-[#CDFF00] transition-colors">Home</Link></li>
              <li><Link to="/about" data-testid="footer-about" className="text-white/80 hover:text-[#CDFF00] transition-colors">About Us</Link></li>
              <li><Link to="/services" data-testid="footer-services" className="text-white/80 hover:text-[#CDFF00] transition-colors">Services</Link></li>
              <li><Link to="/products" data-testid="footer-products" className="text-white/80 hover:text-[#CDFF00] transition-colors">Products</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-lg font-semibold mb-6 font-['Outfit']">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/blog" data-testid="footer-blog" className="text-white/80 hover:text-[#CDFF00] transition-colors">Blog</Link></li>
              <li><Link to="/faq" data-testid="footer-faq" className="text-white/80 hover:text-[#CDFF00] transition-colors">FAQ</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="text-white/80 hover:text-[#CDFF00] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-lg font-semibold mb-6 font-['Outfit']">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail size={20} className="text-[#CDFF00] mt-0.5 flex-shrink-0" />
                <a href="mailto:info@greencircuitev.co.za" className="text-white/80 hover:text-[#CDFF00] transition-colors">
                  info@greencircuitev.co.za
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={20} className="text-[#CDFF00] mt-0.5 flex-shrink-0" />
                <a href="tel:0108228366" className="text-white/80 hover:text-[#CDFF00] transition-colors">
                  010 822 8366
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="text-[#CDFF00] mt-0.5 flex-shrink-0" />
                <span className="text-white/80">
                  30 Paperbark Rd, Fourways<br />Sandton, 2055<br />Johannesburg, South Africa
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-white/60">
              © {new Date().getFullYear()} Green Circuit EV. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-white/60 hover:text-[#CDFF00] transition-colors">Privacy Policy</a>
              <a href="#" className="text-white/60 hover:text-[#CDFF00] transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
